/**
 * Runtime API URL: from /config.json (set in CapRover env) or build-time REACT_APP_API_URL.
 * Use getApiUrl() so the app works without rebuild when backend URL changes.
 */
export function getApiUrl() {
  const fromRuntime = typeof window !== 'undefined' && window.__REACT_APP_API_URL__;
  const fromBuild = process.env.REACT_APP_API_URL;
  const url = (fromRuntime !== undefined && fromRuntime !== '') ? fromRuntime : (fromBuild || '');
  if (!url) return '';
  return url.startsWith('http') ? url : `https://${url}`;
}

export function setApiUrl(url) {
  if (typeof window !== 'undefined') {
    window.__REACT_APP_API_URL__ = url || '';
  }
}
